export default __webpack_public_path__ + "static/Letter_of_Recommendation-88ef73b3fa729160bf708a6f6a4f7578.pdf";